export default "__VITE_ASSET__D$bGNfXB__"